import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/authentication/Login'
import NewPassword from '@/components/authentication/NewPassword'
import Guards from '@/components/pages/Guards'
import Ptt from '@/components/pages/Ptt'
import Guard from '@/components/pages/Guard'
import EspecificGuards from '@/components/pages/EspecificGuards'
import Coordinators from '@/components/pages/Coordinators'
import Coordinator from '@/components/pages/Coordinator'
import Devices from '@/components/pages/Devices'
import Clients from '@/components/pages/Clients'
import Client from '@/components/pages/Client'
import Admins from '@/components/pages/Admins'
import Turn from '@/components/pages/Turn'
import Notice from '@/components/pages/Notice'
import UrgentList from '@/components/pages/Urgents'
import UrgentSingleList from '@/components/pages/Urgent'

import UrgenSingleAlertList from '@/components/pages/UrgentAlerts'

import CreateGuard from '@/components/pages/CreateGuard'
import CreateAdmin from '@/components/pages/CreateAdmin'
import CreateCoordinator from '@/components/pages/CreateCoordinator'
import CreateClient from '@/components/pages/CreateClient'
import CreateDevice from '@/components/pages/CreateDevice'

import EditGuard from '@/components/pages/EditGuard'
import EditAdmin from '@/components/pages/EditAdmin'
import EditCoordinator from '@/components/pages/EditCoordinator'
import EditClient from '@/components/pages/EditClient'
import EditDevice from '@/components/pages/EditDevice'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({

  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/guards',
      name: 'Guards',
      component: Guards
    },
    {
      path: '/ptt',
      name: 'Ptt',
      component: Ptt
    },
    {
      path: '/guards/:id',
      name: 'Guard',
      component: Guard
    },
    {
      path: '/turn/:id',
      name: 'GuardTurn',
      component: Turn
    },
    {
      path: '/coordinators',
      name: 'Coordinators',
      component: Coordinators
    },
    {
      path: '/coordinators/:id',
      name: 'Coordinator',
      component: Coordinator
    },
    {
      path: '/devices',
      name: 'Devices',
      component: Devices
    },
    {
      path: '/clients',
      name: 'Clients',
      component: Clients
    },
    {
      path: '/clients/:id',
      name: 'Client',
      component: Client
    },
    { path: '/clients/:id/:id',
      name: 'EspecificGuards',
      component:EspecificGuards,
    },
    { path: '/coordinators/:id/:id',
      name: 'EspecificGuards',
      component:EspecificGuards,
    },
    {
      path: '/admins',
      name: 'Admins',
      component: Admins
    },
    {
      path: '/createguard',
      name: 'CreateGuard',
      component: CreateGuard
    },
    {
      path: '/editguard/:id',
      name: 'EditGuard',
      component: EditGuard,
      props: true
    },
    {
      path: '/createcoordinator',
      name: 'CreateCoordinator',
      component: CreateCoordinator
    },
    {
      path: '/editcoordinator/:id',
      name: 'EditCoordinator',
      component: EditCoordinator
    },
    {
      path: '/createadmin',
      name: 'CreateAdmin',
      component: CreateAdmin
    },
    {
      path: '/editadmin/:id',
      name: 'EditAdmin',
      component: EditAdmin
    },
    {
      path: '/createclient',
      name: 'CreateClient',
      component: CreateClient
    },
    {
      path: '/editclient/:id',
      name: 'EditClient',
      component: EditClient
    },
    {
      path: '/createdevice',
      name: 'CreateDevice',
      component: CreateDevice
    },
    {
      path: '/editdevice/:id',
      name: 'EditDevice',
      component: EditDevice
    },
    { path: '/newpassword', 
      name: 'NewPassword' ,   
      component: NewPassword },
    { path: '/notice', 
      name: 'Notice' ,   
      component: Notice },
    {
      path: '/urgentlist',
      name: 'UrgentList',
      component: UrgentList
    },
    {
      path: '/urgentlist/:id',
      name: 'UrgentSingleList',
      component: UrgentSingleList
    },
    {
      path: '/urgentalertlist/:id',
      name: 'UrgentSingleAlertList',
      component: UrgenSingleAlertList
    },
     
  ]
})



// WEBPACK FOOTER //
// ./src/vue/router/index.js